// src/hooks/useClinicFeatures.js
import { useEffect, useState } from 'react';
import axiosInstance from '../axiosInstance';
import { useClinic } from '../context/ClinicContext';

export const useClinicFeatures = () => {
  const { selectedClinicId } = useClinic();
  const [state, setState] = useState({
    hasFinanzasAccess: false,
    hasRecordatoriosAccess: false,
    hasReportesAvanzados: false,
    loading: !!selectedClinicId,
    error: null,
  });

  useEffect(() => {
    let abort = false;
    (async () => {
      if (!selectedClinicId) {
        setState({
          hasFinanzasAccess: false,
          hasRecordatoriosAccess: false,
          hasReportesAvanzados: false,
          loading: false,
          error: null,
        });
        return;
      }
      setState((s) => ({ ...s, loading: true, error: null }));
      try {
        const { data } = await axiosInstance.get('/clinica/suscripcion/estado/', {
          params: { clinic_id: selectedClinicId },
        });
        const activa = data?.estado === 'Activa' && !!data?.plan;
        const plan = data?.plan || {};
        const fin = activa && !!plan.permite_acceso_finanzas;
        const rec = activa && !!plan.permite_recordatorios;
        const rep = activa && !!plan.permite_reportes_avanzados;
        if (!abort) {
          setState({
            hasFinanzasAccess: fin,
            hasRecordatoriosAccess: rec,
            hasReportesAvanzados: rep,
            loading: false,
            error: null,
          });
        }
      } catch (e) {
        if (!abort) {
          setState({
            hasFinanzasAccess: false,
            hasRecordatoriosAccess: false,
            hasReportesAvanzados: false,
            loading: false,
            error: 'Error al cargar features de clínica',
          });
        }
      }
    })();
    return () => {
      abort = true;
    };
  }, [selectedClinicId]);

  return state;
};
